// src/pages/tax/Tax.jsx
import React, { useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import TaxZonesTable from "../../components/tax/Zones/TaxZonesTable";
import TaxRatesTable from "../../components/tax/Rates/TaxRatesTable";

const TABS = ["zones", "rates"];

const Tax = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const [searchParams, setSearchParams] = useSearchParams();
    const initial = TABS.includes(searchParams.get("tab")) ? searchParams.get("tab") : "zones";
    const [tab, setTab] = useState(initial);

    const handleChange = (_e, value) => {
        setTab(value);
        const next = new URLSearchParams(searchParams);
        next.set("tab", value);
        setSearchParams(next, { replace: true });
    };

    const labels = useMemo(
        () => ({
            zones: isArabic ? "المناطق" : "Zones",
            rates: isArabic ? "النسب" : "Rates",
        }),
        [isArabic]
    );

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />

            <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2 }}>
                <Tabs value={tab} onChange={handleChange} indicatorColor="primary" textColor="primary">
                    <Tab value="zones" label={labels.zones} />
                    <Tab value="rates" label={labels.rates} />
                </Tabs>
            </Box>

            <Box sx={{ mt: 2 }}>
                {tab === "zones" && <TaxZonesTable />}
                {tab === "rates" && <TaxRatesTable />}
            </Box>
        </WrapperSection>
    );
};

export default Tax;
